import { useEffect } from 'react';
import { EmailVerifiedCheckIcon, EmailVerifiedToastStyled } from './EmailVerifiedToast.styled';

const DEFAULT_DISMISS_MS = 4000;

const EmailVerifiedToast = ({ message, onDismiss, dismissMs = DEFAULT_DISMISS_MS }) => {
    useEffect(() => {
        const timer = setTimeout(() => onDismiss?.(), dismissMs);
        return () => clearTimeout(timer);
    }, [dismissMs, onDismiss]);

    return (
        <EmailVerifiedToastStyled role="status" aria-live="polite">
            <EmailVerifiedCheckIcon>
                <circle cx="12" cy="12" r="12" />
                <path d="M7 12.5L10.5 16L17 9" />
            </EmailVerifiedCheckIcon>
            <p>{message}</p>
        </EmailVerifiedToastStyled>
    );
};

export { EmailVerifiedToast, DEFAULT_DISMISS_MS };
